import React from "react";

import UrlIcon from "../icons/call.svg";

const BookDemoOption = ({actionProvider}) => {
  const options = [
    { text: "📅 Book a Consultation", handler: actionProvider.handleBookDemo, id: 1 ,info:'Manage operations, reports, compliance'},
    { text: "⬅️ Back to Overview", handler: actionProvider.handleFeatures, id: 2 ,info:'Track student progress, manage classes, and communicate with parents'},
    // { text: "👨‍👩‍👧 Parents", handler: actionProvider.handleBookDemo, id: 3 ,info:'View attendance, assignments, and school notifications'},
    // { text: "✅ Book A Demo", handler: actionProvider.handleBookDemo, id: 7 },

  ];
  return (
    <div className="options">
    {/* <p>Qshikshak simplifies school operations by bringing everything—attendance, exams, fees, communication, and more—into one secure platform.</p> */}
    <div className="options-containerF">
        {options.map((option) => {
          return (
            <>
            <div
              className="option-itemF"
              onClick={option.handler}
              key={option.id}
            >
              {option.text}
              
            </div>
            {/* <p  className="option-itemF-info">{option.info}</p> */}
            </>
          );
        })}
      </div>
      {/* <p>Would you like me to show a <span style={{ fontWeight: 'bold' }}>demo tailored for your role?</span></p> */}
  </div>
  );
};

export default BookDemoOption;
